// === Данные блогов для динамического управления ===

export const blogs = [
  {
    id: 1,
    language: 'ru',
    title: 'Гипнотерапия для детей со стоматологической тревожностью',
    slug: 'gipnoterapiya-dlya-detej-so-stomatologicheskoj-trevozhnostyu',
    excerpt: 'Как гипнотерапия помогает детям преодолеть страх перед стоматологом и делает визиты к врачу комфортными и безопасными.',
    content: `
      <div class="space-y-8">
        <h2 class="text-3xl font-bold mb-6">Стоматологическая тревожность у детей</h2>
        <p class="text-lg leading-relaxed mb-8">Страх у детей – распространённая проблема, которая может повлиять как на психическое, так и на физическое здоровье. Гипнотерапия предлагает мягкий и эффективный способ преодолеть эти страхи и сформировать позитивное отношение к стоматологическому лечению.</p>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Основы гипнотерапии для детей</h3>
          <p class="text-lg leading-relaxed">Гипноз – это естественное состояние глубокого расслабления, в котором подсознание особенно восприимчиво к позитивным внушениям. У детей это состояние часто вызывают в игровой форме, приглашая их в мир фантазий или рассказывая им истории.</p>
        </div>
        
        <h3 class="text-xl font-semibold mb-6">Процесс сеанса гипноза</h3>
        
        <div class="space-y-6">
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">1. Анамнез</h4>
            <p class="text-lg leading-relaxed">Подробный разговор с ребёнком и родителями помогает определить причины страха и понять их индивидуальные потребности.</p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">2. Формирование доверия</h4>
            <p class="text-lg leading-relaxed">Непринуждённая атмосфера и понятный, понятный ребёнку язык имеют решающее значение для успеха терапии.</p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">3. Введение</h4>
            <p class="text-lg leading-relaxed">С помощью целенаправленных упражнений на релаксацию и техник визуализации ребёнок погружается в состояние транса.</p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">4. Фаза терапии</h4>
            <ul class="space-y-3 text-lg leading-relaxed">
              <li><strong>Регрессия:</strong> Выявляется и совместно устраняется причина страха.</li>
              <li><strong>Позитивные внушения:</strong> Ребёнок получает позитивные послания и идеи, которые уменьшают страх и заменяют его уверенностью.</li>
              <li><strong>Активация ресурсов:</strong> Укрепляются собственные сильные стороны и способности ребёнка.</li>
              <li><strong>Якорение:</strong> Положительные изменения закрепляются в подсознании, чтобы оставаться эффективными даже вне сеанса.</li>
            </ul>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">5. Разрядка</h4>
            <p class="text-lg leading-relaxed">Ребёнка мягко выводят из транса и возвращают в бодрствующее состояние.</p>
          </div>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Индивидуально разработанные путешествия во сне</h3>
          <p class="text-lg leading-relaxed mb-4">Одним из особенно эффективных методов детского гипноза является путешествие во сне. Ребёнок переносится в мир фантазий, где он может преобразовать свои страхи в позитивный опыт.</p>
          
          <div class="bg-blue-50 border-l-4 border-blue-400 p-6 my-6 rounded-r-lg">
            <p class="text-blue-800 text-lg"><strong>Пример путешествия во сне:</strong> Ребёнок представляет себя отважным исследователем, который находит сундук с сокровищами, полный прекрасных зубов. Стоматолог — дружелюбный помощник, который помогает ему чистить зубы и поддерживать их здоровье.</p>
          </div>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Роль родителей</h3>
          <p class="text-lg leading-relaxed mb-4">Родители играют решающую роль в преодолении страха перед стоматологическими процедурами. Вам следует поддерживать своего ребёнка следующими способами:</p>
          <ul class="space-y-3 text-lg leading-relaxed">
            <li><strong>Позитивное подкрепление:</strong> Похвала и признание смелого поведения.</li>
            <li><strong>Открытое общение:</strong> Обсудите свои страхи и чувства.</li>
            <li><strong>Ролевой пример:</strong> Демонстрируйте спокойное отношение к визиту к стоматологу.</li>
          </ul>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Дополнительные рекомендации</h3>
          <ul class="space-y-3 text-lg leading-relaxed">
            <li><strong>Сочетание с другими методами лечения:</strong> Гипноз хорошо сочетается с другими методами, такими как поведенческая терапия или техники релаксации.</li>
            <li><strong>Гомеопатия:</strong> Гомеопатические средства могут усилить действие гипноза и улучшить общее настроение ребенка.</li>
            <li><strong>Регулярность:</strong> Для достижения устойчивого результата обычно требуется несколько сеансов гипноза.</li>
          </ul>
        </div>
        
        <!-- Секция "Смотрите наши блоги" -->
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h3 class="text-2xl font-bold mb-8 text-center">Смотрите наши блоги</h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <!-- Блог 2 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_733fc059a73a405b8c09991378800496~mv2.avif" 
                alt="Психосоматика и кожа" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Психосоматика и кожа: больше, чем просто поговорка</h4>
                <p class="text-gray-600 text-sm mb-4">Как эмоции влияют на кожу и как гипноз может помочь в исцелении...</p>
                <a href="/blog/psikhosomatika-i-kozha-bolshe-chem-prosto-pogovorka" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 3 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d2dff877e70a405f86aa309ee11cda23~mv2.avif" 
                alt="История г-жи Мюллер" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Невероятная история г-жи Мюллер</h4>
                <p class="text-gray-600 text-sm mb-4">Реальная история преодоления страхов и достижения успеха с помощью гипноза...</p>
                <a href="/blog/neveroyatnaya-istoriya-g-zhi-myuller-i-eyo-porazitelnyh-rezultatov-s-pomoshchyu-gipnoza" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 4 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d3af563dd0dd4c87828063e2dd64ba09~mv2.avif" 
                alt="Панические атаки" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Панические атаки: как обрести внутреннюю безопасность</h4>
                <p class="text-gray-600 text-sm mb-4">Узнайте, как гипнотерапия помогает преодолеть панические атаки...</p>
                <a href="/blog/panicheskie-ataki-kak-obresti-vnutrennyuyu-bezopasnost-i-dushevnoe-spokoystvie" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <a href="/blog" class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
              Смотреть все блоги
            </a>
          </div>
        </div>
      </div>
    `,
    featuredImage: '/images/blogs/f56f7c_34d6e7828f1341339a4945d0f6b2acc5~mv2.avif',
    author: 'Альфира Герман',
    category: 'hypnotherapy',
    tags: ['гипноз', 'пример', 'стоматолог', 'эммендинген', 'тревожность', 'тревожность у стоматолога'],
    status: 'published',
    createdAt: '2024-01-20T10:00:00Z',
    updatedAt: '2024-01-20T10:00:00Z',
    publishedAt: '2024-01-20T10:00:00Z',
    readingTime: 6,
    views: 0,
    likes: 0,
    featured: true,
    seoTitle: 'Гипнотерапия для детей со страхом стоматолога - эффективное решение',
    seoDescription: 'Узнайте, как гипнотерапия помогает детям преодолеть страх перед стоматологом. Безопасные техники и методы работы с детской тревожностью.',
    seoKeywords: ['гипнотерапия дети', 'страх стоматолога', 'детская тревожность', 'стоматологическая фобия']
  },
  {
    id: 2,
    language: 'ru',
    title: 'Психосоматика и кожа: больше, чем просто поговорка',
    slug: 'psikhosomatika-i-kozha-bolshe-chem-prosto-pogovorka',
    excerpt: 'Стресс, психика и кожа: как эмоции влияют на кожу. Узнайте о связи между кожей и душой и как гипнотерапия может помочь в решении психосоматических проблем с кожей.',
    content: `
      <div class="space-y-8">
        <h2 class="text-3xl font-bold mb-6">Связь между кожей и душой</h2>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Стресс как триггер для кожи</h3>
          <p class="text-lg leading-relaxed">Стресс может привести к различным проблемам с кожей, от атопического дерматита до акне. Наша кожа является самым большим органом тела и часто отражает внутреннее эмоциональное состояние.</p>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Эмоции и реакции кожи</h3>
          <p class="text-lg leading-relaxed">Некоторые эмоции, такие как страх, гнев или грусть, могут проявляться на коже. Это происходит потому, что эмоциональные состояния влияют на гормональный баланс и иммунную систему.</p>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Бессознательные конфликты</h3>
          <p class="text-lg leading-relaxed">Проблемы с кожей могут быть проявлением бессознательных конфликтов или травм. Когда мы не можем выразить эмоции словами, тело может говорить за нас через кожные реакции.</p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Гипноз как путь к исцелению</h2>
        <p class="text-lg leading-relaxed mb-8">Гипноз предлагает многообещающий способ решения психосоматических причин проблем с кожей. Благодаря трансу мы можем глубоко проникнуть в наше подсознание и обнаружить первопричины проблем.</p>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Чего можно достичь с помощью гипноза?</h3>
          <ul class="space-y-4 text-lg leading-relaxed">
            <li><strong>Снижение стресса:</strong> Гипноз помогает снизить стресс и способствует расслаблению.</li>
            <li><strong>Проработка эмоций:</strong> Подавленные эмоции можно проработать и интегрировать в трансе.</li>
            <li><strong>Укрепление уверенности в себе:</strong> Гипноз может помочь укрепить уверенность в себе и сформировать позитивный образ тела.</li>
            <li><strong>Облегчение физических симптомов:</strong> Воздействуя на психологические причины, можно облегчить и физические симптомы.</li>
          </ul>
        </div>
        
        <div class="space-y-6">
          <h3 class="text-xl font-semibold mb-4">Как это работает?</h3>
          <p class="text-lg leading-relaxed">В гипнозе внушения используются для позитивного воздействия на подсознание. Например, терапевт может предложить рекомендации, направленные на укрепление иммунной системы, регенерацию кожи и улучшение самочувствия.</p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Истории успеха и перспективы</h2>
        <p class="text-lg leading-relaxed mb-8">Многие люди отмечают значительное улучшение состояния кожи после гипнотерапии. Сочетание традиционного дерматологического лечения и психосоматической поддержки может быть особенно эффективным.</p>
        
        <div class="bg-blue-50 border-l-4 border-blue-400 p-6 my-8 rounded-r-lg">
          <p class="text-blue-800 font-medium text-lg">Важно: Гипноз не заменяет медикаментозное лечение, но может быть полезным дополнением к нему.</p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">4-этапная программа "Кожа как зеркало души"</h2>
        
        <div class="space-y-8">
          <div class="space-y-4">
            <h3 class="text-xl font-semibold mb-4">Шаг 1: Анализ первопричин</h3>
            <p class="text-lg leading-relaxed"><strong>Глубинное интервью:</strong> Подробный разговор для понимания индивидуальных проблем с кожей клиента, жизненных обстоятельств и эмоционального стресса.</p>
          </div>
          
          <div class="space-y-4">
            <h3 class="text-xl font-semibold mb-4">Шаг 2: Эмоциональная проработка и разрешение конфликтов</h3>
            <ul class="space-y-3 text-lg leading-relaxed">
              <li><strong>Гипноз:</strong> Использование техник гипноза для решения и проработки бессознательных конфликтов и травм.</li>
              <li><strong>Методы эмоциональной свободы:</strong> применение таких техник, как EFT (техники эмоциональной свободы), для устранения эмоциональных блоков.</li>
            </ul>
          </div>
          
          <div class="space-y-4">
            <h3 class="text-xl font-semibold mb-4">Шаг 3: Укрепление уверенности в себе и самооценки</h3>
            <p class="text-lg leading-relaxed"><strong>Упражнения на осознанность:</strong> развитие осознанности и самосознания</p>
          </div>
          
          <div class="space-y-4">
            <h3 class="text-xl font-semibold mb-4">Шаг 4: Формирование новых моделей поведения</h3>
            <ul class="space-y-3 text-lg leading-relaxed">
              <li><strong>Методы релаксации:</strong> инструкции по различным техникам релаксации, таким как дыхательные упражнения и прогрессивная мышечная релаксация.</li>
              <li><strong>Индивидуальные планы действий:</strong> разработка индивидуального плана здорового образа жизни, включая питание, сон, физические упражнения и управление стрессом.</li>
            </ul>
          </div>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Важные аспекты программы</h2>
        <ul class="space-y-4 text-lg leading-relaxed">
          <li><strong>Комплексный подход:</strong> взаимосвязь физических, эмоциональных и ментальных аспектов.</li>
          <li><strong>Индивидуализация:</strong> адаптация плана к индивидуальным потребностям и целям каждого клиента.</li>
          <li><strong>Расширение возможностей:</strong> укрепление самоэффективности и личной ответственности клиента.</li>
          <li><strong>Долгосрочная устойчивость:</strong> акцент на устойчивых изменениях образа жизни.</li>
        </ul>
        
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 my-8 rounded-r-lg">
          <p class="text-yellow-800 text-lg"><strong>Важное примечание:</strong> эффективность моей работы зависит от индивидуальных факторов и не может быть гарантирована. Это поддерживающий подход, направленный на стимуляцию собственных исцеляющих сил организма.</p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Заключение</h2>
        <p class="text-lg leading-relaxed mb-6">Проблемы с кожей часто сложны и имеют разнообразные причины. Психосоматика предлагает целостный подход, учитывающий как физические, так и психологические аспекты. Гипноз может быть ценным инструментом для активации способности организма к самоисцелению и развития более здоровых отношений с собственным телом.</p>
        
        <p class="text-lg leading-relaxed">Хотите узнать больше о гипнозе и его применении при проблемах с кожей? Просто позвоните и запишитесь на бесплатную консультацию.</p>
        
        <div class="mt-12">
          <h2 class="text-3xl font-bold mb-6 text-center">Результаты работы с клиентами</h2>
          <p class="text-lg leading-relaxed mb-8 text-center text-gray-600">
            Реальные люди, реальные истории: Здесь вы увидите фотографии людей, которые, как и вы, боролись с проблемами кожи. 
            Проблемы, которые влияли не только на их кожу, но и на качество их жизни. 
            Вместе мы выявили первопричины этих проблем и нашли долгосрочные решения.
          </p>
          
          <div class="bg-gray-50 rounded-2xl p-8">
            <div class="relative overflow-hidden">
              <div class="flex transition-transform duration-500 ease-in-out" id="resultsSlider">
                <!-- Слайд 1 -->
                <div class="w-full flex-shrink-0 px-2">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/1.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/2.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/3.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- Слайд 2 -->
                <div class="w-full flex-shrink-0 px-2">
                  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/4.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/5.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                    <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all cursor-pointer transform hover:scale-105" data-result-image>
                      <img 
                        src="/images/blogs/result/1.webp" 
                        alt="" 
                        class="w-full h-64 object-cover"
                        loading="lazy"
                      />
                      <div class="p-3 text-center">
                        <span class="text-sm text-gray-600">Кликните для увеличения</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <!-- Кнопки навигации -->
              <button class="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all cursor-pointer" onclick="previousSlide()">
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                </svg>
              </button>
              <button class="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transition-all cursor-pointer" onclick="nextSlide()">
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                </svg>
              </button>
              
              <!-- Индикаторы слайдов -->
              <div class="flex justify-center mt-6 space-x-2">
                <button class="w-3 h-3 rounded-full bg-blue-600 transition-all slider-indicator" onclick="goToSlide(0)"></button>
                <button class="w-3 h-3 rounded-full bg-gray-300 hover:bg-gray-400 transition-all slider-indicator" onclick="goToSlide(1)"></button>
              </div>
            </div>
          </div>
          
          <div class="mt-8 text-center">
            <div class="bg-rose-50 border-l-4 border-rose-400 p-6 rounded-r-lg max-w-4xl mx-auto">
              <p class="text-rose-800 text-lg font-medium">
                <strong>Больше, чем просто кожа:</strong> Мой опыт показывает, что многие проблемы с кожей часто коренятся в более глубоких конфликтах, которые выводят нас за рамки наших возможностей. Благодаря целенаправленной работе мы можем разрешить эти конфликты и тем самым исцелить кожу изнутри.
              </p>
            </div>
          </div>
        </div>
        
        <!-- Секция "Смотрите наши блоги" -->
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h3 class="text-2xl font-bold mb-8 text-center">Смотрите наши блоги</h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <!-- Блог 1 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_34d6e7828f1341339a4945d0f6b2acc5~mv2.avif" 
                alt="Гипнотерапия для детей" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Гипнотерапия для детей со стоматологической тревожностью</h4>
                <p class="text-gray-600 text-sm mb-4">Как гипнотерапия помогает детям преодолеть страх перед стоматологом...</p>
                <a href="/blog/gipnoterapiya-dlya-detej-so-stomatologicheskoj-trevozhnostyu" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 3 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d2dff877e70a405f86aa309ee11cda23~mv2.avif" 
                alt="История г-жи Мюллер" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Невероятная история г-жи Мюллер</h4>
                <p class="text-gray-600 text-sm mb-4">Реальная история преодоления страхов и достижения успеха с помощью гипноза...</p>
                <a href="/blog/neveroyatnaya-istoriya-g-zhi-myuller-i-eyo-porazitelnyh-rezultatov-s-pomoshchyu-gipnoza" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 4 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d3af563dd0dd4c87828063e2dd64ba09~mv2.avif" 
                alt="Панические атаки" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Панические атаки: как обрести внутреннюю безопасность</h4>
                <p class="text-gray-600 text-sm mb-4">Узнайте, как гипнотерапия помогает преодолеть панические атаки...</p>
                <a href="/blog/panicheskie-ataki-kak-obresti-vnutrennyuyu-bezopasnost-i-dushevnoe-spokoystvie" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <a href="/blog" class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
              Смотреть все блоги
            </a>
          </div>
        </div>
      </div>
    `,
    featuredImage: '/images/blogs/f56f7c_733fc059a73a405b8c09991378800496~mv2.avif',
    author: 'Альфира Герман',
    category: 'hypnotherapy',
    tags: ['психосоматика', 'кожа', 'стресс', 'гипнотерапия', 'эмоции', 'дерматит', 'акне'],
    status: 'published',
    createdAt: '2024-02-01T10:00:00Z',
    updatedAt: '2024-02-01T10:00:00Z',
    publishedAt: '2024-02-01T10:00:00Z',
    readingTime: 12,
    views: 0,
    likes: 0,
    featured: true,
    seoTitle: 'Психосоматика и кожа: как эмоции влияют на состояние кожи',
    seoDescription: 'Узнайте о связи между психикой и кожей. Как гипнотерапия помогает решить психосоматические проблемы с кожей. 4-этапная программа лечения.',
    seoKeywords: ['психосоматика', 'кожа', 'стресс', 'гипнотерапия', 'дерматит', 'акне', 'эмоции', 'психика']
  },
  {
    id: 3,
    language: 'ru',
    title: 'Невероятная история г-жи Мюллер и её поразительных результатов с помощью гипноза',
    slug: 'neveroyatnaya-istoriya-g-zhi-myuller-i-eyo-porazitelnyh-rezultatov-s-pomoshchyu-gipnoza',
    excerpt: 'Практический пример того, как гипнотерапия помогла г-же Мюллер преодолеть тревогу, неуверенность в себе и достичь невероятных результатов в жизни.',
    content: `
      <div class="space-y-8">
        <div class="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-lg">
          <p class="text-blue-800 text-lg font-medium">
            <strong>Практический пример</strong><br>
            <span class="text-sm text-blue-600">Обновлено: 29 апреля 2024 г.</span>
          </p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Невероятная история г-жи Мюллер и её поразительных результатов с помощью гипноза</h2>
        
        <div class="space-y-6">
          <p class="text-lg leading-relaxed">
            Жила-была женщина по имени г-жа Мюллер, которая годами боролась с тревогой и неуверенностью в себе. Она чувствовала себя запертой в порочном круге негативных мыслей и просто не могла двигаться дальше. Однажды она услышала о силе гипноза и решила попробовать его.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Начало пути к переменам</h3>
        <p class="text-lg leading-relaxed mb-6">
          Г-жа Мюллер встретила отзывчивого гипнотерапевта, который провёл её через подсознание. Во время сеансов гипноза она смогла глубоко погрузиться в себя и распознать свои страхи и блоки. Она поняла, что эти страхи существуют только в её сознании, и что она может отпустить их.
        </p>
        
        <h3 class="text-xl font-semibold mb-4">Процесс трансформации</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            С каждым последующим сеансом г-жа Мюллер чувствовала себя всё более раскрепощённой и уверенной в себе. Она начала видеть новые возможности и бороться со своими страхами.
          </p>
          
          <div class="bg-green-50 border-l-4 border-green-400 p-6 rounded-r-lg">
            <h4 class="text-lg font-semibold text-green-800 mb-3">Достижения г-жи Мюллер:</h4>
            <ul class="space-y-2 text-green-700">
              <li>• Преодолела страх публичных выступлений и произнесла вдохновляющую речь перед большой аудиторией</li>
              <li>• Преодолела страх неудачи и основала собственный успешный бизнес</li>
              <li>• Нашла в себе внутреннюю силу и раскрыла весь свой потенциал</li>
            </ul>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Результаты</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Результаты, достигнутые г-жой Мюллер с помощью гипноза, были просто поразительными. Она нашла в себе внутреннюю силу и раскрыла весь свой потенциал.
          </p>
          
          <div class="bg-rose-50 border-l-4 border-rose-400 p-6 rounded-r-lg">
            <p class="text-rose-800 text-lg font-medium">
              <strong>Сегодня г-жа Мюллер живёт полноценной и счастливой жизнью, освободившись от страхов, которые когда-то сдерживали её.</strong>
            </p>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Что можно извлечь из этой истории</h3>
        <div class="space-y-4">
          <ul class="space-y-3 text-lg leading-relaxed">
            <li><strong>Сила подсознания:</strong> Гипноз позволяет получить доступ к глубоким слоям психики и выявить истинные причины проблем.</li>
            <li><strong>Преодоление страхов:</strong> Работа с подсознанием помогает трансформировать ограничивающие убеждения.</li>
            <li><strong>Раскрытие потенциала:</strong> Освобождение от внутренних блоков открывает новые возможности для роста.</li>
            <li><strong>Долгосрочные изменения:</strong> Гипнотерапия создаёт устойчивые положительные изменения в жизни.</li>
          </ul>
        </div>
        
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
          <p class="text-yellow-800 text-lg">
            <strong>Важно помнить:</strong> Каждый человек уникален, и результаты могут варьироваться. История г-жи Мюллер показывает потенциал гипнотерапии, но не гарантирует одинаковых результатов для всех.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Готовы начать свой путь к переменам?</h3>
        <p class="text-lg leading-relaxed mb-6">
          Если вы, как и г-жа Мюллер, чувствуете, что что-то сдерживает вас от достижения ваших целей, гипнотерапия может стать ключом к вашему освобождению. Запишитесь на консультацию, чтобы обсудить ваши возможности.
        </p>
        
        <!-- Секция "Смотрите наши блоги" -->
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h3 class="text-2xl font-bold mb-8 text-center">Смотрите наши блоги</h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <!-- Блог 1 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_34d6e7828f1341339a4945d0f6b2acc5~mv2.avif" 
                alt="Гипнотерапия для детей" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Гипнотерапия для детей со стоматологической тревожностью</h4>
                <p class="text-gray-600 text-sm mb-4">Как гипнотерапия помогает детям преодолеть страх перед стоматологом...</p>
                <a href="/blog/gipnoterapiya-dlya-detej-so-stomatologicheskoj-trevozhnostyu" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 2 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_733fc059a73a405b8c09991378800496~mv2.avif" 
                alt="Психосоматика и кожа" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Психосоматика и кожа: больше, чем просто поговорка</h4>
                <p class="text-gray-600 text-sm mb-4">Как эмоции влияют на кожу и как гипноз может помочь в исцелении...</p>
                <a href="/blog/psikhosomatika-i-kozha-bolshe-chem-prosto-pogovorka" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 4 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d3af563dd0dd4c87828063e2dd64ba09~mv2.avif" 
                alt="Панические атаки" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Панические атаки: как обрести внутреннюю безопасность</h4>
                <p class="text-gray-600 text-sm mb-4">Узнайте, как гипнотерапия помогает преодолеть панические атаки...</p>
                <a href="/blog/panicheskie-ataki-kak-obresti-vnutrennyuyu-bezopasnost-i-dushevnoe-spokoystvie" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <a href="/blog" class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
              Смотреть все блоги
            </a>
          </div>
        </div>
      </div>
    `,
    featuredImage: '/images/blogs/f56f7c_d2dff877e70a405f86aa309ee11cda23~mv2.avif',
    author: 'Альфира Герман',
    category: 'case-studies',
    tags: ['кейс', 'история успеха', 'тревожность', 'неуверенность', 'гипнотерапия', 'преодоление страхов', 'бизнес'],
    status: 'published',
    createdAt: '2024-04-29T10:00:00Z',
    updatedAt: '2024-04-29T10:00:00Z',
    publishedAt: '2024-04-29T10:00:00Z',
    readingTime: 8,
    views: 0,
    likes: 0,
    featured: true,
    seoTitle: 'История успеха: как г-жа Мюллер преодолела тревожность с помощью гипноза',
    seoDescription: 'Реальная история клиентки, которая с помощью гипнотерапии преодолела тревожность, неуверенность и достигла невероятных результатов в жизни.',
    seoKeywords: ['кейс', 'история успеха', 'тревожность', 'неуверенность', 'гипнотерапия', 'преодоление страхов', 'бизнес', 'публичные выступления']
  },
  {
    id: 4,
    language: 'ru',
    title: 'Панические атаки: как обрести внутреннюю безопасность и душевное спокойствие',
    slug: 'panicheskie-ataki-kak-obresti-vnutrennyuyu-bezopasnost-i-dushevnoe-spokoystvie',
    excerpt: 'Панические атаки могут причинять огромные страдания. Узнайте, как гипнотерапия помогает обрести внутреннюю безопасность, равновесие и душевное спокойствие.',
    content: `
      <div class="space-y-8">
        <h2 class="text-3xl font-bold mb-6">Панические атаки: как обрести внутреннюю безопасность и душевное спокойствие</h2>
        
        <div class="space-y-6">
          <p class="text-lg leading-relaxed">
            Панические атаки могут причинять огромные страдания. Они возникают внезапно и часто без какой-либо определённой причины, сопровождаясь чувством беспомощности, а иногда даже страхом смерти.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Особенности панических атак</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Поскольку они непредсказуемы, их трудно активно избегать. Часто это ошибочные реакции страха, которые трудно контролировать.
          </p>
          
          <div class="bg-red-50 border-l-4 border-red-400 p-6 rounded-r-lg">
            <h4 class="text-lg font-semibold text-red-800 mb-3">Характерные признаки панических атак:</h4>
            <ul class="space-y-2 text-red-700">
              <li>• Внезапное появление без предупреждения</li>
              <li>• Интенсивное чувство страха или тревоги</li>
              <li>• Физические симптомы: учащённое сердцебиение, потливость, дрожь</li>
              <li>• Ощущение нереальности происходящего</li>
              <li>• Страх смерти или потери контроля</li>
              <li>• Желание убежать или спрятаться</li>
            </ul>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Как работает гипнотерапия при панических атаках</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Гипнотерапия предлагает эффективный подход к работе с паническими атаками, воздействуя на их глубинные причины и помогая перестроить реакцию организма на стресс.
          </p>
          
          <div class="grid md:grid-cols-2 gap-6">
            <div class="bg-blue-50 border border-blue-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-blue-800 mb-3">Выявление триггеров</h4>
              <p class="text-blue-700">
                В состоянии гипноза можно безопасно исследовать подсознательные причины, которые запускают панические реакции.
              </p>
            </div>
            
            <div class="bg-green-50 border border-green-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-green-800 mb-3">Перестройка реакций</h4>
              <p class="text-green-700">
                Гипноз помогает создать новые, более спокойные реакции на ситуации, которые ранее вызывали панику.
              </p>
            </div>
            
            <div class="bg-purple-50 border border-purple-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-purple-800 mb-3">Укрепление уверенности</h4>
              <p class="text-purple-700">
                Развитие внутренних ресурсов и техник саморегуляции для преодоления тревоги.
              </p>
            </div>
            
            <div class="bg-orange-50 border border-orange-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-orange-800 mb-3">Техники релаксации</h4>
              <p class="text-orange-700">
                Обучение методам быстрого успокоения, которые можно применять в любой ситуации.
              </p>
            </div>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Процесс работы с паническими атаками</h3>
        <div class="space-y-6">
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">Этап 1: Анализ и понимание</h4>
            <p class="text-lg leading-relaxed">
              Подробное изучение ваших индивидуальных триггеров, физических и эмоциональных реакций во время панических атак.
            </p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">Этап 2: Работа с подсознанием</h4>
            <p class="text-lg leading-relaxed">
              Использование гипноза для доступа к глубинным причинам панических реакций и их трансформации.
            </p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">Этап 3: Развитие навыков саморегуляции</h4>
            <p class="text-lg leading-relaxed">
              Обучение техникам дыхания, визуализации и якорения для быстрого восстановления спокойствия.
            </p>
          </div>
          
          <div class="space-y-4">
            <h4 class="text-lg font-semibold mb-3">Этап 4: Интеграция и закрепление</h4>
            <p class="text-lg leading-relaxed">
              Постепенное внедрение новых реакций в повседневную жизнь и укрепление уверенности в своих способностях.
            </p>
          </div>
        </div>
        
        <div class="bg-rose-50 border-l-4 border-rose-400 p-6 rounded-r-lg">
          <h3 class="text-xl font-semibold mb-4 text-rose-800">Мы поможем вам обрести внутреннюю безопасность, равновесие и душевное спокойствие</h3>
          <p class="text-rose-700 text-lg leading-relaxed">
            Каждый человек заслуживает жить без постоянного страха панических атак. С помощью гипнотерапии вы можете научиться управлять своими реакциями и вернуть себе чувство контроля над собственной жизнью.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Что вы получите в результате</h3>
        <ul class="space-y-3 text-lg leading-relaxed">
          <li><strong>Снижение частоты и интенсивности панических атак</strong></li>
          <li><strong>Умение быстро успокаиваться в стрессовых ситуациях</strong></li>
          <li><strong>Повышение уверенности в себе и своих силах</strong></li>
          <li><strong>Улучшение общего эмоционального состояния</strong></li>
          <li><strong>Возвращение к полноценной активной жизни</strong></li>
        </ul>
        
        <div class="bg-yellow-50 border-l-4 border-yellow-400 p-6 rounded-r-lg">
          <p class="text-yellow-800 text-lg">
            <strong>Важно:</strong> Панические атаки — это серьёзное состояние, которое требует профессиональной помощи. Гипнотерапия является эффективным дополнением к комплексному лечению, но не заменяет консультацию с врачом при необходимости.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Готовы вернуть себе спокойствие?</h3>
        <p class="text-lg leading-relaxed mb-6">
          Не позволяйте паническим атакам контролировать вашу жизнь. Запишитесь на консультацию, чтобы обсудить, как гипнотерапия может помочь вам обрести внутреннюю безопасность и душевное спокойствие.
        </p>
        
        <!-- Секция "Смотрите наши блоги" -->
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h3 class="text-2xl font-bold mb-8 text-center">Смотрите наши блоги</h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <!-- Блог 1 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_34d6e7828f1341339a4945d0f6b2acc5~mv2.avif" 
                alt="Гипнотерапия для детей" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Гипнотерапия для детей со стоматологической тревожностью</h4>
                <p class="text-gray-600 text-sm mb-4">Как гипнотерапия помогает детям преодолеть страх перед стоматологом...</p>
                <a href="/blog/gipnoterapiya-dlya-detej-so-stomatologicheskoj-trevozhnostyu" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 2 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_733fc059a73a405b8c09991378800496~mv2.avif" 
                alt="Психосоматика и кожа" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Психосоматика и кожа: больше, чем просто поговорка</h4>
                <p class="text-gray-600 text-sm mb-4">Как эмоции влияют на кожу и как гипноз может помочь в исцелении...</p>
                <a href="/blog/psikhosomatika-i-kozha-bolshe-chem-prosto-pogovorka" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 3 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d2dff877e70a405f86aa309ee11cda23~mv2.avif" 
                alt="История г-жи Мюллер" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Невероятная история г-жи Мюллер</h4>
                <p class="text-gray-600 text-sm mb-4">Реальная история преодоления страхов и достижения успеха с помощью гипноза...</p>
                <a href="/blog/neveroyatnaya-istoriya-g-zhi-myuller-i-eyo-porazitelnyh-rezultatov-s-pomoshchyu-gipnoza" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <a href="/blog" class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
              Смотреть все блоги
            </a>
          </div>
        </div>
      </div>
    `,
    featuredImage: '/images/blogs/f56f7c_d3af563dd0dd4c87828063e2dd64ba09~mv2.avif',
    author: 'Альфира Герман',
    category: 'hypnotherapy',
    tags: ['панические атаки', 'тревожность', 'страх', 'гипнотерапия', 'психология', 'саморегуляция', 'релаксация'],
    status: 'published',
    createdAt: '2024-04-29T14:30:00Z',
    updatedAt: '2024-04-29T14:30:00Z',
    publishedAt: '2024-04-29T14:30:00Z',
    readingTime: 10,
    views: 0,
    likes: 0,
    featured: true,
    seoTitle: 'Панические атаки: как гипнотерапия помогает обрести спокойствие',
    seoDescription: 'Узнайте, как гипнотерапия помогает справиться с паническими атаками. Эффективные методы обретения внутренней безопасности и душевного спокойствия.',
    seoKeywords: ['панические атаки', 'тревожность', 'страх', 'гипнотерапия', 'психология', 'саморегуляция', 'релаксация', 'лечение']
  },
  {
    id: 5,
    language: 'ru',
    title: 'Гипноз — мощный инструмент для преодоления страхов',
    slug: 'gipnoz-moshchnyy-instrument-dlya-preodoleniya-strahov',
    excerpt: 'Хотите избавиться от страхов и жить свободной жизнью? Гипноз — мощный инструмент, который поможет вам преодолеть страхи и избавиться от них навсегда.',
    content: `
      <div class="space-y-8">
        <div class="bg-blue-50 border-l-4 border-blue-400 p-6 rounded-r-lg">
          <p class="text-blue-800 text-lg font-medium">
            <strong>Обновлено: 29 апреля 2024 г.</strong>
          </p>
        </div>
        
        <h2 class="text-3xl font-bold mb-6">Гипноз — мощный инструмент для преодоления страхов</h2>
        
        <div class="space-y-6">
          <p class="text-lg leading-relaxed">
            Хотите избавиться от страхов и жить свободной жизнью? Представьте, как вы можете достичь этого с помощью гипноза. Гипноз — мощный инструмент, который поможет вам преодолеть страхи и избавиться от них навсегда.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Как гипноз помогает преодолеть страхи</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            С помощью гипноза вы сможете исследовать глубинные причины своих страхов и понять, как они влияют на вашу жизнь. Гипнотерапия поможет вам изменить негативные убеждения и мыслительные модели, связанные со страхами, и заменить их позитивными и уверенными мыслями.
          </p>
          
          <div class="bg-green-50 border-l-4 border-green-400 p-6 rounded-r-lg">
            <h4 class="text-lg font-semibold text-green-800 mb-3">Что происходит во время гипнотерапии:</h4>
            <ul class="space-y-2 text-green-700">
              <li>• Исследование глубинных причин страхов</li>
              <li>• Понимание влияния страхов на вашу жизнь</li>
              <li>• Изменение негативных убеждений</li>
              <li>• Замена ограничивающих мыслей на позитивные</li>
              <li>• Развитие уверенности в себе</li>
            </ul>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Результаты освобождения от страхов</h3>
        <div class="space-y-4">
          <p class="text-lg leading-relaxed">
            Освободившись от страхов, вы откроете для себя новые возможности и выйдете на новый уровень личностного развития. Вы сможете смело двигаться вперед, преодолевать препятствия и достигать своих целей.
          </p>
          
          <div class="grid md:grid-cols-2 gap-6">
            <div class="bg-purple-50 border border-purple-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-purple-800 mb-3">Новые возможности</h4>
              <ul class="space-y-2 text-purple-700">
                <li>• Открытие новых путей развития</li>
                <li>• Расширение зоны комфорта</li>
                <li>• Пробуждение скрытого потенциала</li>
                <li>• Улучшение качества жизни</li>
              </ul>
            </div>
            
            <div class="bg-orange-50 border border-orange-200 rounded-xl p-6">
              <h4 class="text-lg font-semibold text-orange-800 mb-3">Личностный рост</h4>
              <ul class="space-y-2 text-orange-700">
                <li>• Повышение уверенности в себе</li>
                <li>• Улучшение самооценки</li>
                <li>• Развитие внутренней силы</li>
                <li>• Достижение поставленных целей</li>
              </ul>
            </div>
          </div>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Типы страхов, с которыми работает гипнотерапия</h3>
        <div class="space-y-4">
          <div class="grid md:grid-cols-3 gap-4">
            <div class="bg-blue-50 border border-blue-200 rounded-xl p-4">
              <h4 class="text-lg font-semibold text-blue-800 mb-2">Социальные страхи</h4>
              <p class="text-blue-700 text-sm">Боязнь публичных выступлений, социального взаимодействия</p>
            </div>
            
            <div class="bg-red-50 border border-red-200 rounded-xl p-4">
              <h4 class="text-lg font-semibold text-red-800 mb-2">Специфические фобии</h4>
              <p class="text-red-700 text-sm">Страх высоты, закрытых пространств, животных</p>
            </div>
            
            <div class="bg-yellow-50 border border-yellow-200 rounded-xl p-4">
              <h4 class="text-lg font-semibold text-yellow-800 mb-2">Экзистенциальные страхи</h4>
              <p class="text-yellow-700 text-sm">Страх неудачи, изменения, неизвестности</p>
            </div>
          </div>
        </div>
        
        <div class="bg-rose-50 border-l-4 border-rose-400 p-6 rounded-r-lg">
          <h3 class="text-xl font-semibold mb-4 text-rose-800">Начните новую главу своей жизни без страха!</h3>
          <p class="text-rose-700 text-lg leading-relaxed mb-4">
            Не откладывайте свою свободу. Начните менять свою жизнь с помощью гипноза уже сегодня. Запишитесь на приём прямо сейчас и начните новую главу своей жизни без страха!
          </p>
          <p class="text-rose-800 text-lg font-semibold">
            Позвоните сейчас и получите первые 30 минут бесплатно.
          </p>
        </div>
        
        <h3 class="text-xl font-semibold mb-4">Преимущества гипнотерапии при работе со страхами</h3>
        <ul class="space-y-3 text-lg leading-relaxed">
          <li><strong>Быстрые результаты:</strong> Гипноз позволяет работать с подсознанием напрямую, ускоряя процесс исцеления</li>
          <li><strong>Безопасность:</strong> Вы остаётесь в полном контроле на протяжении всего сеанса</li>
          <li><strong>Долгосрочность:</strong> Изменения происходят на глубоком уровне и сохраняются надолго</li>
          <li><strong>Индивидуальный подход:</strong> Каждый сеанс адаптируется под ваши уникальные потребности</li>
          <li><strong>Естественность:</strong> Гипноз — это естественное состояние сознания, которое вы уже испытываете ежедневно</li>
        </ul>
        
        <h3 class="text-xl font-semibold mb-4">Готовы освободиться от страхов?</h3>
        <p class="text-lg leading-relaxed mb-6">
          Каждый человек заслуживает жить свободной от страхов жизнью. С помощью гипнотерапии вы можете преодолеть любые ограничения и открыть для себя мир новых возможностей. Не позволяйте страхам контролировать вашу жизнь — возьмите контроль в свои руки уже сегодня.
        </p>
        
        <!-- Секция "Смотрите наши блоги" -->
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h3 class="text-2xl font-bold mb-8 text-center">Смотрите наши блоги</h3>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <!-- Блог 1 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_34d6e7828f1341339a4945d0f6b2acc5~mv2.avif" 
                alt="Гипнотерапия для детей" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Гипнотерапия для детей со стоматологической тревожностью</h4>
                <p class="text-gray-600 text-sm mb-4">Как гипнотерапия помогает детям преодолеть страх перед стоматологом...</p>
                <a href="/blog/gipnoterapiya-dlya-detej-so-stomatologicheskoj-trevozhnostyu" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 2 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_733fc059a73a405b8c09991378800496~mv2.avif" 
                alt="Психосоматика и кожа" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Психосоматика и кожа: больше, чем просто поговорка</h4>
                <p class="text-gray-600 text-sm mb-4">Как эмоции влияют на кожу и как гипноз может помочь в исцелении...</p>
                <a href="/blog/psikhosomatika-i-kozha-bolshe-chem-prosto-pogovorka" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
            
            <!-- Блог 3 -->
            <div class="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all">
              <img 
                src="/images/blogs/f56f7c_d2dff877e70a405f86aa309ee11cda23~mv2.avif" 
                alt="История г-жи Мюллер" 
                class="w-full h-48 object-cover"
                loading="lazy"
              />
              <div class="p-6">
                <h4 class="text-lg font-semibold mb-3">Невероятная история г-жи Мюллер</h4>
                <p class="text-gray-600 text-sm mb-4">Реальная история преодоления страхов и достижения успеха с помощью гипноза...</p>
                <a href="/blog/neveroyatnaya-istoriya-g-zhi-myuller-i-eyo-porazitelnyh-rezultatov-s-pomoshchyu-gipnoza" class="text-blue-600 hover:text-blue-800 font-medium">Читать далее →</a>
              </div>
            </div>
          </div>
          
          <div class="text-center">
            <a href="/blog" class="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
              Смотреть все блоги
            </a>
          </div>
        </div>
      </div>
    `,
    featuredImage: '/images/blogs/f56f7c_53c38c5b4c6142158bdd47480bb558c7~mv2.avif',
    author: 'Альфира Герман',
    category: 'hypnotherapy',
    tags: ['гипноз', 'страхи', 'фобии', 'гипнотерапия', 'преодоление', 'свобода', 'развитие', 'уверенность'],
    status: 'published',
    createdAt: '2024-04-29T16:00:00Z',
    updatedAt: '2024-04-29T16:00:00Z',
    publishedAt: '2024-04-29T16:00:00Z',
    readingTime: 8,
    views: 0,
    likes: 0,
    featured: true,
    seoTitle: 'Гипноз — мощный инструмент для преодоления страхов и фобий',
    seoDescription: 'Узнайте, как гипноз помогает избавиться от страхов навсегда. Мощный инструмент для преодоления фобий и достижения свободы от ограничений.',
    seoKeywords: ['гипноз', 'страхи', 'фобии', 'гипнотерапия', 'преодоление', 'свобода', 'развитие', 'уверенность', 'лечение']
  }
];

// Функции для работы с блогами
export const blogUtils = {
  // Получить все опубликованные блоги
  getPublishedBlogs: (language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.status === 'published');
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs;
  },
  
  // Получить рекомендуемые блоги
  getFeaturedBlogs: (language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.featured === true);
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs;
  },
  
  // Получить блоги по категории
  getBlogsByCategory: (category, language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.category === category);
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs;
  },
  
  // Получить блоги по тегам
  getBlogsByTag: (tag, language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.tags.includes(tag));
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs;
  },
  
  // Найти блог по slug
  getBlogBySlug: (slug, language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.slug === slug);
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs[0] || null;
  },
  
  // Найти блог по ID
  getBlogById: (id) => blogs.find(blog => blog.id === id),
  
  // Получить последние блоги
  getLatestBlogs: (limit = 5, language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.status === 'published');
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs
      .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
      .slice(0, limit);
  },
  
  // Получить популярные блоги (по просмотрам)
  getPopularBlogs: (limit = 5, language = null) => {
    let filteredBlogs = blogs.filter(blog => blog.status === 'published');
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs
      .sort((a, b) => b.views - a.views)
      .slice(0, limit);
  },
  
  // Поиск по блогам
  searchBlogs: (query, language = null) => {
    const lowercaseQuery = query.toLowerCase();
    let filteredBlogs = blogs.filter(blog => 
      blog.status === 'published' && (
        blog.title.toLowerCase().includes(lowercaseQuery) ||
        blog.excerpt.toLowerCase().includes(lowercaseQuery) ||
        blog.content.toLowerCase().includes(lowercaseQuery) ||
        blog.tags.some(tag => tag.toLowerCase().includes(lowercaseQuery))
      )
    );
    if (language) {
      filteredBlogs = filteredBlogs.filter(blog => blog.language === language);
    }
    return filteredBlogs;
  },

  // Получить все языки
  getAvailableLanguages: () => {
    const languages = [...new Set(blogs.map(blog => blog.language))];
    return languages;
  },

  // Получить статистику по языкам
  getLanguageStats: () => {
    const stats = {};
    blogs.forEach(blog => {
      if (!stats[blog.language]) {
        stats[blog.language] = { total: 0, published: 0, draft: 0, featured: 0 };
      }
      stats[blog.language].total++;
      if (blog.status === 'published') stats[blog.language].published++;
      if (blog.status === 'draft') stats[blog.language].draft++;
      if (blog.featured) stats[blog.language].featured++;
    });
    return stats;
  }
};

// Категории блогов
export const blogCategories = [
  { id: 'hypnotherapy', name: 'Гипнотерапия', description: 'Статьи о гипнотерапии', color: 'bg-purple-100 text-purple-800' },
  { id: 'case-studies', name: 'Кейсы', description: 'Реальные истории клиентов', color: 'bg-yellow-100 text-yellow-800' }
];

// Популярные теги (только те, которые используются в статьях)
export const popularTags = [
  'гипноз', 'пример', 'стоматолог', 'эммендинген', 'тревожность', 'тревожность у стоматолога',
  'психосоматика', 'кожа', 'стресс', 'гипнотерапия', 'эмоции', 'дерматит', 'акне',
  'кейс', 'история успеха', 'неуверенность', 'преодоление страхов', 'бизнес',
  'панические атаки', 'страх', 'психология', 'саморегуляция', 'релаксация',
  'страхи', 'фобии', 'преодоление', 'свобода', 'развитие', 'уверенность'
];
